import { render, staticRenderFns } from "./CustomerHubHistory.vue?vue&type=template&id=29848953&scoped=true"
import script from "./CustomerHubHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHubHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubHistory.vue?vue&type=style&index=0&id=29848953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29848953",
  null
  
)

export default component.exports